import { render, staticRenderFns } from "./ShareTypeEffectiveness.vue?vue&type=template&id=efcd449a&"
import script from "./ShareTypeEffectiveness.vue?vue&type=script&lang=js&"
export * from "./ShareTypeEffectiveness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports